export class TextareaReplacementUtil {
  text: string;

  constructor(text = '') {
    this.text = text;
  }

  /**
   * Expands legacy single newlines into markdown paragraph breaks. Newlines
   * touching a dash are left alone so list nesting survives.
   */
  replacesOneNewLineWithTwo(v: string = this.text) {
    this.text = v ? v.replaceAll(/(?<!-)\n(?!-)/gi, '\n\n') : v;
    return this;
  }

  /** Inverse of replacesOneNewLineWithTwo, applied before a legacy value is persisted. */
  replacesTwoNewLinesWithOne(v: string = this.text) {
    this.text = v ? v.replaceAll(/(?<!-)(\n){2}/g, '\n') : v;
    return this;
  }

  // Fix for bug: FR-3889
  // See https://regexr.com/80cqr to see documentation on what this RegEx does
  replaceEmptyBulletListItem(v: string = this.text) {
    this.text = v ? v.replaceAll(/^ *((-+ *)+\n?$)+/gm, '') : v;
    return this;
  }

  /**
   * Fix for bug: FR-4511 — see https://regexr.com/82d32 for what this RegEx does.
   *
   * Kept for envoy's legacy `RichTextEditor`, which calls it. The Textarea does
   * not: Lexical reads indented text as a paragraph rather than a code block,
   * and this would flatten the indentation nested list items export with.
   */
  replaceFourOrMoreStartingSpaces(v: string = this.text) {
    this.text = v ? v.replaceAll(/^(- )? {4,}/gm, '$1') : v;
    return this;
  }

  /**
   * The leading whitespace each rule captures is put back rather than dropped,
   * as it was previously: markdown reads it as list nesting, so discarding it
   * flattens every nested item to the top level.
   */
  replaceUncommonBulletFormatToCommon(v: string = this.text) {
    if (!v) return this;

    const bulletCharacters = ['•', '●', '○', '§', '·', 'o', '-'];

    // formats unordered lists
    bulletCharacters.forEach(c => {
      // Create a regex to match bullet patterns at line start or tab start
      let bulletRegex = new RegExp(String.raw`(^|\n)([ \t]*)${c}[ \t]*`, 'g');
      // some users like to use the letter "o"
      if (c === 'o') {
        bulletRegex = new RegExp(String.raw`(^|\n)([ \t]*)${c}[ \t]+`, 'g');
      }

      v = v.replace(bulletRegex, '$1$2- ');

      // Replace the starting bullet with '- ' if it starts with the character followed by space or tab
      const bulletStartRegex = new RegExp(`^${c}[ \t]`);
      if (bulletStartRegex.test(v)) {
        v = v.replace(bulletStartRegex, '- ');
      }
    });

    // formats numeric lists
    const numericRegex = /(^|\n)([\t ]*)(\d[).])[\t ]*/g;
    v = v.replaceAll(numericRegex, '$1$2$3 ');

    // Remove all tabs - tabs can cause text to not render in Textarea
    v = v.replaceAll('\t', '');

    // cleans up spacing when bulleted list is preceded by \n\n
    v = v.replaceAll('\n\n- ', '\n- ');

    this.text = v;
    return this;
  }

  getText() {
    return this.text;
  }
}
